import { useMutation } from 'react-query';
import request from '../../../../../../helpers/request';
import { useDispatch } from 'react-redux';
import { fetchShutdownsThunk } from '../../../../shared/model/actions';

const changeInitiators = async ({ shutdownId, data }) => {
  const res = await request.put(
    `/Alert/initiators/${shutdownId}`,
    data,
    'Не удалось изменить список инициаторов',
    'Error'
  );

  return res;
};

export const useShutdownInitiatorsChange = (options = {}) => {
  const dispatch = useDispatch();

  const changeMutation = useMutation(changeInitiators, {
    ...options,
    onSuccess: async (res, { shutdownId }) => {
      if (res !== 'Error') {
        dispatch(fetchShutdownsThunk());
      }
    },
  });

  return {
    change: changeMutation.mutateAsync,
    loading: changeMutation.isLoading,
  };
};
